import Frontend from './Frontend'

export default Frontend
